<template>

<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M448.376,71.138c4.151,0,7.515-3.364,7.515-7.515V7.515c0-4.151-3.364-7.515-7.515-7.515H63.624
			c-4.151,0-7.515,3.364-7.515,7.515v496.971c0,4.151,3.364,7.515,7.515,7.515h297.581c1.97,0,3.921-0.809,5.314-2.2l87.17-87.17
			c1.393-1.393,2.2-3.346,2.2-5.314V99.699c0-4.151-3.364-7.515-7.515-7.515s-7.515,3.364-7.515,7.515V409.8h-79.656
			c-4.151,0-7.515,3.364-7.515,7.515v79.656H71.139V15.029h369.722v48.594C440.861,67.774,444.225,71.138,448.376,71.138z
			 M368.72,424.83h61.514l-61.514,61.514V424.83z"/>
	</g>
</g>
<g>
	<g>
		<path d="M408.297,56.11H103.703c-4.151,0-7.515,3.364-7.515,7.515v104.203c0,4.151,3.364,7.515,7.515,7.515h304.595
			c4.151,0,7.515-3.364,7.515-7.515V63.624C415.812,59.473,412.449,56.11,408.297,56.11z M400.783,160.313H111.217V71.139h289.566
			V160.313z"/>
	</g>
</g>
<g>
	<g>
		<path d="M239.969,192.376H103.703c-4.151,0-7.515,3.364-7.515,7.515v192.376c0,4.151,3.364,7.515,7.515,7.515h136.266
			c4.151,0,7.515-3.364,7.515-7.515V199.89C247.483,195.739,244.12,192.376,239.969,192.376z M232.454,384.751H111.217V207.405
			h121.237V384.751z"/>
	</g>
</g>
<g>
	<g>
		<path d="M408.297,192.376H272.031c-4.151,0-7.515,3.364-7.515,7.515v80.157c0,4.151,3.364,7.515,7.515,7.515h136.266
			c4.151,0,7.515-3.364,7.515-7.515V199.89C415.812,195.739,412.449,192.376,408.297,192.376z M400.783,272.532H279.546v-65.127
			h121.237V272.532z"/>
	</g>
</g>
<g>
	<g>
		<path d="M408.297,304.595H272.031c-4.151,0-7.515,3.364-7.515,7.515v80.157c0,4.151,3.364,7.515,7.515,7.515h136.266
			c4.151,0,7.515-3.364,7.515-7.515V312.11C415.812,307.958,412.449,304.595,408.297,304.595z M400.783,384.751H279.546v-65.127
			h121.237V384.751z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
